import { useCallback } from 'react';

export function useMergedRefs<T = any>(refs: Array<React.MutableRefObject<T> | React.LegacyRef<T>>) {
	return useCallback((element: T) => {
		refs.forEach((ref) => {
			if (!ref) return;
			if (typeof ref === 'function') {
				ref(element);
			} else {
				(ref as React.MutableRefObject<T | null>).current = element;
			}
		});
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, refs);
}
